import { Alert, AlertProps, Snackbar } from '@mui/material';
import { useAtom } from 'jotai';
import { simpleAlertAtom } from '../atoms';

export const SimpleAlert = () => {
    const [{ title, show, severity }, setAlertState] = useAtom(simpleAlertAtom);

    const handleClose = () => {
        setAlertState((prev) => ({ ...prev, show: false }));
    };

    return (
        <Snackbar open={show} autoHideDuration={5000} onClose={handleClose}>
            <Alert onClose={handleClose} severity={severity} variant="filled" sx={{ width: '100%' }}>
                {title}
            </Alert>
        </Snackbar>
    );
};

export const useSimpleAlert = () => {
    const [, setAlertState] = useAtom(simpleAlertAtom);

    const handleShow = ({ title, severity = 'success' }: { title: string; severity?: AlertProps['severity'] }) => {
        setAlertState({ title, severity, show: true });
    };

    return {
        showSimpleAlert: handleShow,
    };
};
